import React, { useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { useTheme } from '@mui/material/styles';
import './QuoteTable.css';
import QuoteTimeline from './QuoteTimeline';

const QuoteTable = ({ quotes = [], logs = [] }) => {
    const theme = useTheme();
    // Check if dark mode is enabled
    const isDarkMode = theme.palette.mode === 'dark';

    console.log('Theme mode:', theme.palette.mode); // Debug output
    console.log('Is dark mode:', isDarkMode);

    // Define columns
    const columns = useMemo(() => [
        {
            accessorKey: 'id',
            header: 'Quote ID',
            size: 120,
        },
        {
            accessorKey: 'customer',
            header: 'Customer',
            size: 200,
        },
        {
            accessorKey: 'status',
            header: 'Status',
            size: 150,
        },
        {
            accessorKey: 'latestUpdate',
            header: 'Latest Update',
            size: 200,
        },
        {
            accessorKey: 'entryCount',
            header: '# of Entries',
            size: 150,
        },
    ], []);

    // Process data
    const data = useMemo(() => {
        return quotes.map((quote) => {
            const quoteLogs = logs.filter((log) => log.quote_id === quote.id);
            const latest = quoteLogs.length > 0 ? quoteLogs[quoteLogs.length - 1].date_logged : null;
            return {
                ...quote,
                customer: quote.customer || 'Unknown',
                status: typeof quote.status === 'object' ? quote.status.Name : quote.status,
                latestUpdate: latest,
                entryCount: quoteLogs.length,
                subRows: quoteLogs
                    .filter(log => log.type && log.type !== 'unclassified')
                    .map((log) => ({
                        message: log.message,
                        date: log.date_logged,
                        type: log.type,
                    })),
            };
        });
    }, [quotes, logs]);

    // Define table instance
    const table = useMaterialReactTable({
        columns,
        data,
        enableColumnResizing: true,
        columnResizeMode: 'onChange',
        layoutMode: 'grid',
        // This is critical - material-react-table needs this
        enableStickyHeader: true,

        // Explicitly pass theme mode
        muiTableProps: {
            sx: { backgroundColor: isDarkMode ? '#121212' : undefined }
        },

        // Critical: This is what enables dark mode in material-react-table
        enableDarkMode: isDarkMode,

        // Additional styling to ensure dark mode is applied
        displayColumnDefOptions: {
            'mrt-row-expand': {
                muiTableHeadCellProps: {
                    sx: { color: isDarkMode ? '#fff' : undefined }
                },
            },
        },
        muiTableHeadCellProps: {
            sx: {
                backgroundColor: isDarkMode ? '#1e1e1e' : undefined,
                color: isDarkMode ? '#fff' : undefined
            }
        },
        muiTableBodyCellProps: {
            sx: {
                backgroundColor: isDarkMode ? '#121212' : undefined,
                color: isDarkMode ? '#e0e0e0' : undefined
            }
        },
        muiTablePaperProps: {
            sx: { backgroundColor: isDarkMode ? '#121212' : undefined }
        },
        muiTableContainerProps: {
            sx: { backgroundColor: isDarkMode ? '#121212' : undefined }
        },
        muiBottomToolbarProps: {
            sx: { backgroundColor: isDarkMode ? '#121212' : undefined }
        },
        muiTopToolbarProps: {
            sx: { backgroundColor: isDarkMode ? '#121212' : undefined }
        },

        renderDetailPanel: ({ row }) => (
            <div style={{ padding: '10px' }}>
                <strong>Status Changes:</strong>
                <QuoteTimeline logs={row.original.subRows || []} />
            </div>
        ),


    });

    return <MaterialReactTable table={table} />;
};

export default QuoteTable;